import {httpClient} from "./httpClient";

export type UserProfile = {
    login: string;
    contract_address: string | null;
    static_addresses?: string[];
    generated_addresses_count: number;
    generated_addresses_balance: number;
    computers_total: number;
    computers_online: number;
    pool_enabled: boolean;
};

export async function fetchUserProfile(): Promise<UserProfile> {
    const {data} = await httpClient.get<UserProfile>("/users/me");
    return data;
}

export type StaticAddressData = {
    type_id: number;
    address: string;
    generation: boolean;
    pattern: string;
};

export type StaticAddressSetData = {
    type_id: number;
    address: string;
    generation: boolean;
};

export type SetStaticAddressesResponse = {
    status: string;
};

export async function setStaticAddresses(addresses: StaticAddressSetData[]): Promise<SetStaticAddressesResponse> {
    const {data} = await httpClient.post<SetStaticAddressesResponse>("/users/staticAddress/set", addresses);
    return data;
}

export type GetStaticAddressesResponse = {
    static_addresses: StaticAddressData[];
};

export async function getStaticAddresses(): Promise<GetStaticAddressesResponse> {
    const {data} = await httpClient.get<GetStaticAddressesResponse>("/users/staticAddress/getList");
    return data;
}

